// extracted by mini-css-extract-plugin
export default {"description":"Basics_description__llJRH"};